<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="我的球杆"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-card
          shadow="never"
          class="my-card"
          v-for="club in clubList"
          :key="club.id">
        <template #desc>
          <div class="info-item">
            <span class="label">序列号:</span>
            <span class="value value_xlh">{{ club.value }}</span>
          </div>
          <div class="info-item">
            <span class="label">品牌:</span>
            <span class="value value_xlh">{{ club.brand }}</span>
          </div>
          <div class="info-item">
            <span class="label">系列:</span>
            <span class="value value_xlh">{{ club.model }}</span>
          </div>
          <!-- 只有提交过权益申请才显示状态-->
          <div class="info-item" v-if="club.businessId && (club.state == '1' || club.state == '2')">
            <span class="label">状态:</span>
            <span v-if="club.state == '1'" class="value value_xlh">{{ club.type=='1'?'置换':'翻新' }}审核中</span>
            <span v-if="club.state == '2'" class="value value_xlh">{{ club.type=='1'?'置换':'翻新' }}中</span>
          </div>
        </template>
      </van-card>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {benefitsByUser} from "@/api/sales";
import {Dialog} from "vant";

export default {
  data(){
    return {
      clubList: [],
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.go(-1);
    },
    //获取当前登录人名下注册登记的球杆
    selectProductByUser(){
      benefitsByUser().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.clubList = res.data;
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
          }).then(() => {
            // on close
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '请稍后重试',
        });
      })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
}

.my-card{
  margin: 15px;
  border-radius: 12px;
  background: #fff;
  border: none;
}
.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #0f0f0f;
    width: 80px;
  }

  .value {
    color: #0f0f0f;
    word-break: break-all;
  }
}
</style>